export default function collapse() {
  function collapse(open, iten, body, active) {
    let speed = '300';
    $('body').on('click', open, function () {
      if ($(this).closest(iten).find(body).is(':visible')) {
        $(this).closest(iten).find(body).slideUp(speed);
        $(this).removeClass(active);
      } else {
        $(body).slideUp(speed);
        $(open).removeClass(active);
        $(this).closest(iten).find(body).slideDown(speed);
        $(this).addClass(active);
      }
    });
  }
  collapse('[data-openquestion]', '.faq__iten', '.faq__description', 'faq__question--active');
}